import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { HandleActivitiesSummarizedByStudentUseCaseInterface } from 'domain/usecases';

interface IActivitiesSummarizedByStudent {
  data: HandleActivitiesSummarizedByStudentUseCaseInterface.Result;
}

interface IPayloadData
  extends PayloadAction<HandleActivitiesSummarizedByStudentUseCaseInterface.Result> {}

const initialState: IActivitiesSummarizedByStudent = {
  data: [],
};

export const ActivitiesSummarizedByStudentSlice = createSlice({
  name: 'activities-summarized-by-student',
  initialState,
  reducers: {
    loadActivitiesSummarizedByStudent: (state, action: IPayloadData) => {
      state.data = action.payload;
    },
    clearActivitiesSummarizedByStudent: (state) => {
      state.data = [];
    },
  },
});

export const {
  loadActivitiesSummarizedByStudent,
  clearActivitiesSummarizedByStudent,
} = ActivitiesSummarizedByStudentSlice.actions;

export default ActivitiesSummarizedByStudentSlice.reducer;
